






























































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {$, MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import ContraSenhaDestinatario from '@/model/resource/ContraSenhaDestinatario'
import Papa from 'papaparse'
import {FileObject} from 'image-compressor.js'
import * as Helper from '@/helpers'
import {AppConfig} from '@/config/app.config'
import PersistContraSenhaDestinatarioRequest from '@/model/request/PersistContraSenhaDestinatarioRequest'

const metaInfo = () => ({
  title: $.t('view.manage.countersign.title'),
})

@Component({
  metaInfo,
})
export default class ManageCountersignView extends Mixins(MixinUpload) {
  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  selectedCountersign: ContraSenhaDestinatario | null = null

  list: ContraSenhaDestinatario[] = []
  listCountersign: string[] | null = null

  get listWithNull() {
    return [new ContraSenhaDestinatario(), ...this.list]
  }

  async mounted() {
    await this.populate()
  }

  @Watch('selectedCountersign.cpfCnpj')
  async selectedCountersignEvent(cpfCnpj: string | null) {
    if (cpfCnpj && this.selectedCountersign) {
      const {data} = await this.selectedCountersign.listContraSenhasByCpfCnpj()
      this.listCountersign = data
    } else {
      this.listCountersign = null
    }
  }

  async populate() {
    const {data} = await ContraSenhaDestinatario.listCpfCnpjContraSenhaDestinatario()
    this.list = data.map((cpfCnpj) => {
      const model = new ContraSenhaDestinatario()
      model.cpfCnpj = cpfCnpj
      return model
    })
  }

  @Watch('files') // upload
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.contraSenhas
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const request = new PersistContraSenhaDestinatarioRequest()
    request.countersigns = data.map((item) => {
      const model = new ContraSenhaDestinatario()
      model.celDestinatario = item.contraSenha
      model.cpfCnpj = item.cpfCnpj
      return model
    })

    try {
      await request.persistContraSenhaDestinatario()
    } finally {
      $.await.done('uploadCsv')
    }

    Helper.success('system.success.persist')

    await this.populate()
    this.selectedCountersign = null
  }

  async downloadCsv() {
    const {data} = await this.$await.run(() => ContraSenhaDestinatario.listContraSenhaDestinatario(), 'downloadCsv')
    const list = data.map((item: ContraSenhaDestinatario) => ({
      'CPF / CNPJ - DESTINATARIO': Helper.cpfOrCnpj(item.cpfCnpj),
      'CEL - DESTINATARIO': item.celDestinatario,
    }))
    const csv = Papa.unparse(list)
    Helper.createCsvFile('Lista Contra Senha.csv', csv)
  }
}
